export default require("../../node_modules/.pnpm/axios@0.27.2/node_modules/axios/index.js");